<template>
     <ul class="calendar-bundle__footer-calc-list">
        <li class="calendar-bundle__footer-calc-list-item">
            <span :class="isComda ? 'comda-footer-calc-list-item__key' : 'mlp-footer-calc-list-item__key'">
                Unit Price:
            </span>
            <span class="footer-calc-list-item__val">${{ Number(priceByQty ? priceByQty.toFixed(2) : 0.00).toFixed(2) }}/Each</span>
        </li>
        <li class="calendar-bundle__footer-calc-list-item">
            <span :class="isComda ? 'comda-footer-calc-list-item__key' : 'mlp-footer-calc-list-item__key'">
                Total Quantity:
            </span>
            <span class="footer-calc-list-item__val">{{ totalQty }}</span>
        </li>
        <li class="calendar-bundle__footer-calc-list-item">
            <span :class="isComda ? 'comda-footer-calc-list-item__key' : 'mlp-footer-calc-list-item__key'">
                Sub-Total:
            </span>
            <span class="footer-calc-list-item__val">${{ Number(priceByQty * totalQty).toFixed(2) }}</span>
        </li>
    </ul>

</template>

<script>
import { store } from './store'

export default {
    props: {
        totalQty: Number,
        priceByQty: Number
    },

    data() {
        return {
            store: store,
            qtyIncrement: 25
        }
    },
    /*
    computed: {
        computed: {
            updateTotalLine() {
                console.error("updateTotalLine");
                console.log(this.store.totalQty);
                console.log(typeof this.store.totalQty);
                console.log(this.store.priceByQty);
                console.log(typeof this.store.priceByQty);
                console.warn(this.store.totalQty * this.store.priceByQty);

                return {
                    priceByQty: `$${this.store.priceByQty} / Each`,
                    totalQty: `${this.store.totalQty}`,
                    totalPriceByQty: `$${(this.store.totalQty * this.store.priceByQty).toFixed(2)}`
                }
            },
        },
    },*/
    computed: {
      isComda() {
        return window.location.href.includes('comda');
      },
    },
    methods: {
        onChange (value) {
            console.error("change");
            console.log(value);
            this.value = value;
            this.$emit('customQtyChange', {value: value, prIndex: this.prIndex, prID: this.product.id});
        }
    },
    created() {
        console.error("Created Footer");
        console.log(this.totalQty);
        console.log(this.priceByQty);

    }
}


</script>

<style>

</style>